export enum MarketingStatus {
   PAUSE = 0,
   ACTIVE = 1,
}
